import React from 'react';
import ClientList from './ClientList';

export default function Tab() {
    return <ClientList />;
}
